import { ErrorCodeConverter } from "./ErrorCodeConverter";
import DateConverter from "./DateConverter";

export const convertErrorCode = (errorCodeString: string) =>
  new ErrorCodeConverter().convert(errorCodeString);
export const dateConverter = new DateConverter();
